var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"radio\" ng-class=\"{ selected: $ctrl.selected }\"\u003E\u003Cinput class=\"input-radio\" type=\"radio\" ng-attr-name=\"{{ $ctrl.name }}\" ng-attr-checked=\"{{ $ctrl.selected }}\"\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/application/component/radio/radio.tpl.pug
// module id = l/u7
// module chunks = 0